export const ACCESS_DENIED_MESSAGE = 'access_denied';
export const ACCESS_DENIED_STEP = 'access-denied';
export const AUTHORIZATION_STEP = 'authorization';

export const MAX_DESCRIPTION_CHARS = 300;
export const MAX_DESCRIPTION_CHARS_PREVIEW = 300;
